/**
 * Initialize Swiper sliders for gallery blocks
 */

/* global Swiper */

document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelectorAll('.gallery-slider').length) {
    return;
  }

  const sliderGalleries = document.querySelectorAll('.gallery-slider');

  sliderGalleries.forEach((gallery, index) => {
    const slidesPerView = parseInt(gallery.dataset.slidesPerView) || 3;
    const galleryId = `gallery-slider-${index}`;

    gallery.id = galleryId;
    gallery.classList.add('swiper');

    // Restructure for Swiper
    const slides = Array.from(gallery.children).filter((child) =>
      child.matches('a, figure, .media-image-item')
    );
    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    slides.forEach((slide) => {
      slide.classList.add('swiper-slide');
      wrapper.appendChild(slide);
    });

    gallery.appendChild(wrapper);

    // Add custom navigation controls
    const navHTML = `
            <div class="slider-controls">
                <button class="slider-btn slider-prev" aria-label="Previous slide">
                    <i class="fa-regular fa-arrow-left"></i>
                </button>
                <button class="slider-btn slider-next" aria-label="Next slide">
                    <i class="fa-regular fa-arrow-right"></i>
                </button>
            </div>
        `;

    gallery.insertAdjacentHTML('beforeend', navHTML);

    // Initialize Swiper
    new Swiper(`#${galleryId}`, {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: `#${galleryId} .slider-next`,
        prevEl: `#${galleryId} .slider-prev`,
      },
      breakpoints: {
        640: {
          slidesPerView: Math.min(2, slidesPerView),
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: slidesPerView,
          spaceBetween: 30,
        },
      },
      loop: true,
    });
  });
});
